import ApplyParagraphAnnotations from "@elements/ArticleParagraph/ApplyParagraphAnnotations";
import Heading from "@elements/Typography/Heading";
import { ProcessedSubHead } from "@typings/Opensearch";
import { twMerge } from "tailwind-merge";

type SubHeadProps = {
  element: ProcessedSubHead;
};

export default function SubHead({ element }: SubHeadProps) {
  return (
    <Heading
      className={twMerge(
        "font-opensans font-normal text-md px-3 md:px-5 lg:px-0",
        element.headingTag === "h2" &&
          "text-lg font-bold leading-6.7 py-4 md:pb-2.5 lg:py-3",
      )}
      Element={element.headingTag}
    >
      {ApplyParagraphAnnotations(element.subhead, element.annotations)}
    </Heading>
  );
}
